import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useConvexAuth } from 'convex/react'
import { useEffect } from 'react'
import { FullPageSpinner } from '@/components/common/full-page-spinner'

export const Route = createFileRoute('/callback')({
  component: CallbackComponent,
})

function CallbackComponent() {
  const navigate = useNavigate()
  const { isAuthenticated, isLoading } = useConvexAuth()

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      const pendingRedirect = sessionStorage.getItem('postAuthRedirectTo')
      if (pendingRedirect) {
        sessionStorage.removeItem('postAuthRedirectTo')
        window.location.href = pendingRedirect
        return
      }
      void navigate({ to: '/', replace: true })
    } else if (!isLoading && !isAuthenticated) {
      void navigate({ to: '/sign-in', replace: true })
    }
  }, [isAuthenticated, isLoading, navigate])

  return <FullPageSpinner message="Completing sign in..." />
}
